import React from 'react';
import FramedSmtStencil from 'shared/product_tabs/tab_stencils/components/product_parameters/FramedSmtStencil';
import PrototypeSmtStencil from 'shared/product_tabs/tab_stencils/components/product_parameters/PrototypeSmtStencil';
import FramelessSmtStencil from 'shared/product_tabs/tab_stencils/components/product_parameters/FramelessSmtStencil';

const ProductParameters = (props) => {
  const { product } = props;
  if (!product) return null;
  const selectedProduct = product || Spree.stencils_info[0];

  let ProductForm = PrototypeSmtStencil;

  if (selectedProduct.id === 40) ProductForm = FramedSmtStencil;
  if (selectedProduct.id === 24) ProductForm = FramelessSmtStencil;

  return (
    <ProductForm
      {...props}
      product={selectedProduct} />
  );
};

export default ProductParameters;
